import { useTheme } from "@emotion/react";
import { Box, Grid2, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import React from "react";
import styled from "@emotion/styled";
import { LoadingSpinner } from "@rentablo/components";
import { WhitelistBank } from "../banksList";

const BankImage = styled(Box)(({ theme }) => ({
  borderRadius: "6px",
  overflow: "hidden",
  width: "24px",
  height: "24px",
  flexShrink: 0,
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.background.paper,

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
}));

export const BankOptionSmall = ({
  bank,
  onClick,
  isFetching,
}: {
  bank: WhitelistBank;
  onClick: (bank: WhitelistBank) => void;
  isFetching: boolean;
}) => {
  const theme = useTheme();
  return (
    <Grid2
      data-testid="bank-option-small"
      size={{
        sm: 6,
        md: 4,
        xs: 12,
      }}
    >
      <Paper
        onClick={() => onClick(bank)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "48px",
          paddingRight: "12px",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: theme.palette.background.subtle,
          },
        }}
      >
        <Box p={3} display="flex" alignItems="center" gap={2}>
          <BankImage>
            <img src={bank.iconUrl} alt={bank.name} />
          </BankImage>
          <Typography variant="body3" noWrap>
            {bank.name}
          </Typography>
        </Box>
        {isFetching && <LoadingSpinner width={20} />}
      </Paper>
    </Grid2>
  );
};
